import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors: {
    primary: {
      50: '#fff0ed',
      100: '#ffd6ce',
      200: '#ffb8ab',
      300: '#ff9a87',
      400: '#ff7e67',
      500: '#FF5C41',
      600: '#e04a30',
      700: '#c03820',
      800: '#92310a',
      900: '#6b1f00',
    },
    accent: {
      success: '#48BB78',
      warning: '#ECC94B',
      danger: '#FC8181',
      info: '#63B3ED',
    },
    gray: {
      50: '#F7FAFC',
      100: '#EDF2F7',
      200: '#E2E8F0',
      300: '#CBD5E0',
      400: '#A0AEC0',
      500: '#718096',
      600: '#4A5568',
      700: '#2D3748',
      800: '#1A202C',
      900: '#171923',
    },
    ui: {
      main: '#FF5C41',
      secondary: '#EDF2F7',
      success: '#48BB78',
      danger: '#E53E3E',
      light: '#FAFAFA',
      dark: '#1A202C',
      darkSlate: '#252D3D',
      dim: '#A0AEC0',
    },
  },
  fonts: {
    heading: '"Inter", system-ui, sans-serif',
    body: '"Inter", system-ui, sans-serif',
  },
  sizes: {
    container: {
      content: '1200px',
    },
  },
  components: {
    Button: {
      variants: {
        primary: {
          backgroundColor: 'primary.500',
          color: 'white',
          fontWeight: 'semibold',
          borderRadius: '8px',
          px: 6,
          py: 3,
          _hover: {
            backgroundColor: 'primary.600',
            transform: 'translateY(-1px)',
            boxShadow: 'md',
          },
          _active: {
            transform: 'translateY(0)',
          },
        },
        outline: {
          border: '2px solid',
          borderColor: 'primary.500',
          color: 'primary.400',
          _hover: {
            bg: 'whiteAlpha.100',
          },
        },
        ghost: {
          color: 'gray.300',
          _hover: {
            bg: 'gray.800',
          },
        },
      },
    },
  },
  styles: {
    global: {
      'html, body, #root': {
        minHeight: '100dvh',
      },
      body: {
        bg: 'gray.900',
        color: 'gray.100',
      },
    },
  },
});

export default theme;
